import React, { useState } from 'react'
import { TimelineAccordionContainer, TimelineAccordionContent, TimelineAccordionTitle } from './styles'
import { IconComponent } from '~/assets/icons/component'

export interface TimelineAccordionProps {
  title: string
  content: React.ReactNode
  startOpen?: boolean
}

export const TimelineAccordion = ({ content, title, startOpen }: TimelineAccordionProps): JSX.Element => {
  const [accordionIsOpen, setAccordionIsOpen] = useState(startOpen ?? true)

  const handleOpenAccordion = () => {
    setAccordionIsOpen(!accordionIsOpen)
  }

  return (
    <TimelineAccordionContainer>
      <TimelineAccordionTitle onClick={handleOpenAccordion} isOpen={accordionIsOpen}>
        {title} <IconComponent name="chevronRight" />
      </TimelineAccordionTitle>
      <TimelineAccordionContent isOpen={accordionIsOpen}>{content}</TimelineAccordionContent>
    </TimelineAccordionContainer>
  )
}
